<template>
  <div
    class="relative overflow-hidden rounded-2xl px-7 py-6 bg-gradient-to-br from-[#1c1f26] to-[#181b21] border border-red-500/10 print:border-green-500/80 transition-all duration-500 group"
  >
    <!-- Glow decorativo (inspirado no Leonardo) -->
    <div
      class="absolute w-40 h-40 rounded-full opacity-70 group-hover:opacity-100 transition-all duration-500 blur-3xl"
      :class="[
        highlight ? 'bg-red-500/50' : '',
        rightbottom ? 'bg-blue-500/50 -bottom-10 -right-10' : '',
        righttop ? 'bg-yellow-500/50 -top-10 -right-10' : '',
        center ? 'bg-green-500/50 -top-8 left-10' : '',
      ]"
    />

    <!-- Conteúdo -->
    <div class="relative flex flex-col justify-between h-full min-h-[120px]">
      <!-- Título -->
      <div
        class="text-base font-semibold text-gray-400 tracking-wide print:text-black"
      >
        {{ label }}
      </div>

      <!-- Valor -->
      <div
        class="text-6xl font-semibold text-white tracking-tight print:text-black"
      >
        {{ value }}
      </div>
      <slot />
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  label: String,
  value: [String, Number],
  highlight: Boolean,
  righttop: Boolean,
  rightbottom: Boolean,
  center: Boolean,
});
</script>
